import { ReactElement, ReactNode } from 'react'
import styled from 'styled-components'
import { CloseIcon } from 'components/Icons'

const OverlayWrapper = styled.div<{ top?: string }>`
  z-index: 1;
  position: absolute;
  top: ${({ top }): string => top || '166px'};
  right: 0;
  transform: translateX(100%);
  max-height: ${({ top }): string => (top ? `calc(100% - ${top})` : 'calc(100% - 166px)')};
  overflow: auto;
`

const OverlayContainer = styled.div<{ width?: string }>`
  border-radius: 0px 16px 16px 0px;
  border: 1px solid #e3e3e3;
  background: #fff;
  padding: 40px 24px 24px;
  width: ${({ width }): string => width || '360px'};
  position: relative;
`

const CloseAction = styled.div`
  position: absolute;
  top: 12px;
  right: 24px;
  display: flex;
  cursor: pointer;
  margin: -4px;
  padding: 4px;
  &:hover {
    opacity: 0.7;
  }
`

const StyledCloseIcon = styled(CloseIcon)`
  width: 20px;
  height: 20px;
  fill: #916ee8;
`

interface ISidebarOverlayProps {
  onClose: () => void
  children: ReactNode
  top?: string
  width?: string
}

export const SidebarOverlay = ({ onClose, children, top, width }: ISidebarOverlayProps): ReactElement => {
  return (
    <OverlayWrapper top={top}>
      <OverlayContainer width={width}>
        <CloseAction onClick={onClose}>
          <StyledCloseIcon />
        </CloseAction>
        {children}
      </OverlayContainer>
    </OverlayWrapper>
  )
}
